import { render, staticRenderFns } from "./AtfAccordionListItems.vue?vue&type=template&id=65f93764&"
import script from "./AtfAccordionListItems.vue?vue&type=script&lang=js&"
export * from "./AtfAccordionListItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports